import React, {Component} from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { history } from "../router";
import LoadingDots from "./ui/LoadingDots/LoadingDots";
import moment from 'moment';

import { copyForm, deleteForm, revokeForm, welcome as welcomeAction } from "../actions";

import HistoryStatusModal from './program/history/';
import {FORMS_URL} from '../router/urls';

class RequestList extends Component {
  modal;

  constructor() {
    super();
    this.onDelete = this.onDelete.bind(this);
    this.onCopy = this.onCopy.bind(this);
    this.onRevoke = this.onRevoke.bind(this);
    this.showHistory = this.showHistory.bind(this);
    this.welcome = this.welcome.bind(this);

    this.modal = HistoryStatusModal;
  }

  welcome(process_id) {
    welcomeAction({request_id: process_id, project: 'fasttrack_on_status'}, {
      success: () => {
        window.location.pathname = '/planner/'
      },
      error: () => {
        window.location.pathname = '/planner/'
      }
    });
  }

  goForm(event, opts) {
    event.stopPropagation();
    event.preventDefault();
    const {form_type, process_id} = opts;
    history.push(FORMS_URL({form_type, process_id}))
  }

  onDelete(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.deleteForm(form_type, process_id);
  }

  onCopy(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.copyForm(form_type, process_id);
  }

  onRevoke(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.revokeForm(form_type, process_id);
  }

  onPropagation = (event) => {
    event.stopPropagation();
  }

  getRowAct(item) {
      return item.stage_title;
  }
  getRowOp(item) {
    if (item.process_completed) {
      return 'Не требуется'
    }
    if (item.process_stage === 100) {
      return (
          <button onClick={event => this.goForm(event, {form_type: item.init_type, process_id: item.process_id})}>
            Заполнить заявку
          </button>
      )
    }
    if (item.process_stage === 200) {
      return (
        <>
          <button onClick={event => this.goForm(event, {form_type: item.init_type, process_id: item.process_id})}>
            Заполнить заявку
          </button>
          <button onClick={event => this.goForm(event, {form_type: item.form_type, process_id: item.process_id})}>
            Запрос документов
          </button>
        </>
      )
    }
  }
  getProcessStatus(item) {
    if (item.process_status) {
      return item.process_status
    } else {
      if (item.process_completed) {
        return 'Завершено'
      }
        switch(item.form_status) {
          case 0: return 'Черновик'
          case 6: return 'На рассмотрении'
          case 10: return 'Ожидает отзыва'
          default: return 'Неизвестно'
        }
    }
  }
  showHistory(e, request) {
    e.stopPropagation();
    e.preventDefault();

    this.modal.show(request);

  }

  flowData(flow) {
    if (typeof flow === 'undefined') return (<div/>)
    return (
        <div>
          {flow.name} ({moment(flow.recruitment_date_start).format('DD.MM.YYYY')} - {moment(flow.recruitment_date_end).format('DD.MM.YYYY')})
        </div>
    )
  }

  render() {
    const {forms, mode, loaders, flows} = this.props;
    return (
      <LoadingDots show={['forms', 'flows', 'mm-process','slave-mentors','mentor-process','companies'].some(el => loaders[el]) || !this.props.modeLoaded}>
        {forms.length > 0 && (
          <div className='table-responsive text-block'>
            <table className='table table-bordered table-hover request-list'>
              <thead>
                <tr>
                  <td>ID</td>
                  <td>Дата</td>
                  <td>Рег.№</td>
                  <td>Дата рег.</td>
                  <td>Стадия</td>
                  {mode === 'working' && (
                    <>
                      <td>Статус</td>
                      <td>Действие</td>
                      <td>Операции</td>
                    </>
                  )}
                </tr>
               </thead>
               <tbody>
                {/*TODO:
                  По возможности продумать как убрать без боли мутацию массив
                  [...forms].sort((a,b) => a.process_id > b.process_id ? 1 : -1) или вынести в отдельную функцию
                */}
                {forms.sort((a, b) => a.process_id > b.process_id ? 1 : -1).map(item => (
                  <tr
                      className='report-list-group'
                      key={item.process_id}
                      onClick={event => this.goForm(event,{form_type: item.form_type, process_id: item.process_id})}
                  >
                    <td className='label-num-cell'>
                      <span className="no-desktop">№&nbsp;</span>{item.process_id || ''}
                    </td>
                    <td>
                      <span className="no-desktop">Дата:&nbsp;</span> {moment(item.form_date).format('DD.MM.YYYY')}
                    </td>
                    <td>
                      <span className="no-desktop">Рег.№&nbsp;</span> {item.registration_number || ''}
                    </td>
                    <td>
                      <span className="no-desktop">Дата рег.:&nbsp;</span> {item.registration_date ? moment(item.registration_date).format('DD.MM.YYYY') : ''}
                    </td>
                    <td>
                      <span className="no-desktop">Стадия:&nbsp;</span> {this.getRowAct(item)}
                    </td>
                    {mode === 'working'
                    &&
                    <>
                      <td>
                        <div className="btn-group-vertical" role="group">
                            <label className="btn btn-primary">{this.getProcessStatus(item)}</label>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={(event) => this.showHistory(event, item.process_id)}
                            >
                              История
                            </button>
                        </div>
                      </td>
                      {/* <td>
                        {this.getRowOp(item)}
                      </td> */}
                      <td>
                        {/*TODO: вынести кнопки в отдельный компонент если они используются в других компонентах в проекте*/}
                        {/* <button
                            className="btn btn-primary btn-xs"
                            title="Клонировать"
                            onClick={event => this.onCopy(event, item.form_type, item.process_id)}
                        >
                            <span className="glyphicon glyphicon-duplicate" />
                        </button> */}
                        &nbsp;
                        {item?.invoice_file && (
                          <a
                              className="btn btn-warning btn-xs"
                              download
                              title="Загрузить счёт"
                              href={item?.invoice_file}
                              target='_blank'
                              onClick={this.onPropagation}
                          >
                            <span className="glyphicon glyphicon-download-alt" />
                          </a>
                        )}
                        &nbsp;
                        {item.form_status === 0 && (
                          <button
                              className="btn btn-danger btn-xs"
                              title="Удалить"
                              onClick={event => this.onDelete(event, item.form_type, item.process_id)}
                          >
                            <span className="glyphicon glyphicon-remove" />
                          </button>
                        )}
                        &nbsp;
                        {item?.invoice_file && <a className="btn btn-primary btn-xs" onClick={(e) => {e.stopPropagation(); this.welcome(item.process_id);}} title="Запланировать встречу">
                          Запланировать встречу
                        </a>}
                        {/*
                        &nbsp;
                          {item.form_status != 0 && <button className="btn btn-primary btn-xs" onClick={event => this.onRevoke(event, item.form_type, item.process_id)} title="Отозвать">
                            <span className="glyphicon glyphicon-arrow-left" />
                          </button>}
                        */}
                      </td>
                    </>}
                  </tr>
                ))}
               </tbody>
            </table>
            <HistoryStatusModal ref={(modal) => this.modal = modal }/>
          </div>
        )}
        {forms.length === 0 && (
          <div className='text-block text-block_empty'>
            Не найдено ни одной заявки
          </div>
        )}
      </LoadingDots>
    )
  }
}

RequestList.propTypes = {
  forms: PropTypes.array.isRequired,
  flows: PropTypes.array,
  loaders: PropTypes.shape({}).isRequired,
};

RequestList.defaultProps = {
  flows: []
}

const mapDispatchToProps = {
  copyForm,
  deleteForm,
  revokeForm
};

function mapStateToProps(state) {
  return {
    mode: state.forms.mode,
    forms: state.forms.forms,
    loaders: state.forms.loaders,
    modeLoaded: state.forms.modeLoaded,
    flows: state.forms.flows,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestList);
